import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_33: FaireProductEntity = {
  token: "starter_collection_33",
  type: "product",
  name: "The Mk Free Board",
  brandName: "Material",
  imageUrl: "",
  priceDollars: 55,
  msrpDollars: 110,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
